import styled from "@emotion/styled";
import { theme } from "styles/theme";

export const Container = styled.div`
  box-sizing: border-box;
  min-width: 1060px;
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const Heading = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  align-self: stretch;
`;

export const ProfileContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 44px 24px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;

export const Name = styled.p`
  font-size: 24px;
  font-weight: 600;
  color: ${theme.neutral900};
`;

export const LinkContainer = styled.div`
  background-color: white;
  border: 1px solid ${theme.neutral100};
  border-radius: 100px;
  display: flex;
  padding: 12px 16px;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: ${theme.neutral100};
  }
`;

export const LinkLabel = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: ${theme.neutral500};
`;

export const SectionTitle = styled.p<{ isPressed?: boolean }>`
  font-weight: 600;
  font-size: 17px;
  padding: 0 12px 8px 12px;
  border-bottom: ${(props) => (props.isPressed ? `2px solid ${theme.primary500}` : "none")};
  color: ${(props) => (props.isPressed ? `${theme.neutral900}` : `${theme.neutral400}`)};

  cursor: pointer;
`;

export const SectionGroup = styled.div`
  position: relative;
  display: flex;
  padding: 24px 24px 0 24px;
  gap: 12px;

  box-sizing: border-box;
  width: 100%;
  border-bottom: 1px solid ${theme.neutral100};
`;

export const Clipboard = styled.p`
  font-size: 16px;
  color: ${theme.primary500};
  font-weight: 700;
  align-items: center;
  display: flex;
  gap: 4px;

  &:hover {
    color: #3174dd;
  }

  cursor: pointer;
`;

export const VisitInfoPreview = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${theme.neutral500};

  cursor: pointer;
  text-decoration: underline;
`;
